import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Logo from './Logo';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import Button from './Button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Programmes', path: '/programmes' },
    { name: 'For Organisations', path: '/for-organisations' },
    { name: 'About', path: '/about' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ease-in-out ${isScrolled ? 'bg-epoq-paper/90 backdrop-blur-md py-4 border-b border-epoq-blue/10' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex justify-between items-center">
        <Link to="/" className="z-50 relative top-2">
          <Logo className="w-32 lg:w-40" />
        </Link>
        
        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center space-x-10">
          <div className="flex space-x-8">
            {navLinks.map((link) => (
              <NavLink 
                key={link.name} 
                to={link.path}
                className={({isActive}) => `text-sm tracking-wide transition-colors ${isActive ? 'font-medium opacity-100' : 'opacity-60 hover:opacity-100'}`}
              >
                {link.name}
              </NavLink>
            ))}
          </div>
          <div className="flex items-center space-x-4 border-l border-epoq-blue/20 pl-8">
            <Link to="/contact" className="text-sm tracking-wide opacity-60 hover:opacity-100 transition-opacity">Contact</Link>
            <Button to="/programmes" variant="primary" size="sm">Explore programmes</Button>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden z-50 p-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu">
          {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed inset-0 bg-epoq-paper z-40 pt-32 px-6 flex flex-col"
          >
            <div className="flex flex-col space-y-8 text-2xl font-serif">
              {navLinks.map((link) => (
                <NavLink 
                  key={link.name} 
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="border-b border-epoq-blue/10 pb-4"
                >
                  {link.name}
                </NavLink>
              ))}
              <NavLink to="/contact" onClick={() => setIsOpen(false)} className="border-b border-epoq-blue/10 pb-4">Contact</NavLink>
            </div>
            <div className="mt-12 flex flex-col space-y-4">
              <Button to="/programmes" variant="primary" className="w-full justify-center">Explore programmes</Button>
              <Button to="/contact" variant="outline" className="w-full justify-center">Discuss a company programme</Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;